import type {
  AlphaCreateEditBody,
  AlphaDesignVersion,
} from "@nlc/shared-types";

import { useMutation, type UseMutationResult } from "@tanstack/react-query";

import { createAlphaEdit } from "../api/alphaEditor.api";
import { useOpenCreatedVersion } from "./useOpenCreatedVersion";

export function useCreateAlphaEdit(
  requestId: number,
  designId: string,
  parentVersionId: string,
): UseMutationResult<AlphaDesignVersion, Error, AlphaCreateEditBody> {
  const openCreatedVersion = useOpenCreatedVersion(requestId, designId);

  return useMutation({
    mutationFn: (body) => createAlphaEdit(requestId, parentVersionId, body),
    onSuccess: openCreatedVersion,
  });
}
